import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { BarVerticalStackedComponent } from '@swimlane/ngx-charts';
var StackedVerticalBarComponent = /** @class */ (function () {
    function StackedVerticalBarComponent() {
        this.subscriptions = new Subject();
        this.colors = ['#fc3868', '#24b787'];
        this.barPadding = 30;
    }
    StackedVerticalBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var navbar = document.querySelector('fce-sidebar');
        fromEvent(navbar, 'toggleSidebar')
            .pipe(takeUntil(this.subscriptions), debounceTime(100), filter(function () { return !!_this.chart; }))
            .subscribe(function () { return _this.chart.update(); });
    };
    StackedVerticalBarComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    StackedVerticalBarComponent.prototype.toIntegerAxis = function (value) {
        return Number(value).toPrecision();
    };
    StackedVerticalBarComponent.prototype.beforePrint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.chart) {
                    return [2 /*return*/];
                }
                this.barPadding = 10;
                this.chart.animations = false;
                this.chart.view = [600, 340];
                this.chart.update();
                return [2 /*return*/];
            });
        });
    };
    StackedVerticalBarComponent.prototype.afterPrint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.chart) {
                    return [2 /*return*/];
                }
                this.barPadding = 30;
                this.chart.animations = true;
                this.chart.view = null;
                this.chart.update();
                return [2 /*return*/];
            });
        });
    };
    return StackedVerticalBarComponent;
}());
export { StackedVerticalBarComponent };
